import { S as SocialLoginResponseStatus } from '../../chuck/SocialLoginResponseStatus-BP1cpX8W.js';

var kakaoSDKVersion = '2.7.2';
var kakaoIntegrityValue = 'sha384-TiCUE00h649CAMonG018J2ujOgDKW/kVWlChEuu4jK2vxfAAD0eZxzCKakxg55G4';
var KakaoSdkLogin = function(config) {
    return new Promise(function(resolve, reject) {
        var popupWindow = window.open('', 'kakao-auth-popup', 'width=390,height=844');
        if (!popupWindow) {
            reject({
                status: SocialLoginResponseStatus.Error,
                error: 'Failed to open popup window'
            });
            return;
        }
        var sdkScript = popupWindow.document.createElement('script');
        sdkScript.id = 'kakao-jssdk';
        sdkScript.src = "https://t1.kakaocdn.net/kakao_js_sdk/" + kakaoSDKVersion + "/kakao.min.js";
        sdkScript.async = true;
        sdkScript.defer = true;
        sdkScript.crossOrigin = 'anonymous';
        sdkScript.integrity = "" + kakaoIntegrityValue;
        sdkScript.addEventListener('load', function() {
            if (popupWindow.Kakao) {
                var kakaoSdk = popupWindow.Kakao;
                kakaoSdk.init(config.appKey);
                if (kakaoSdk.isInitialized()) {
                    kakaoSdk.Auth.authorize({
                        redirectUri: config.redirectUri,
                        throughTalk: config.throughTalk
                    });
                } else {
                    reject({
                        status: SocialLoginResponseStatus.Error,
                        error: "Kakao SDK initialization failed."
                    });
                }
            } else {
                reject({
                    status: SocialLoginResponseStatus.Error,
                    error: "Kakao SDK is not available."
                });
            }
        });
        sdkScript.addEventListener('error', function() {
            return reject(new Error('Kakao SDK Error loading script.'));
        });
        sdkScript.addEventListener('abort', function() {
            return reject(new Error('Kakao SDK Script loading aborted.'));
        });
        popupWindow.document.body.appendChild(sdkScript);
        var checkPopupClosed = setInterval(function() {
            if (popupWindow.closed) {
                clearInterval(checkPopupClosed);
                reject({
                    status: SocialLoginResponseStatus.Error,
                    error: "Popup window closed before authorization."
                });
            }
            try {
                var popupUrl = popupWindow.location.href;
                var urlParams = new URLSearchParams(new URL(popupUrl).search);
                var code = urlParams.get('code');
                if (code) {
                    clearInterval(checkPopupClosed);
                    resolve({
                        code: code,
                        status: SocialLoginResponseStatus.Success,
                        context: {
                            redirect_uri: config.redirectUri
                        }
                    });
                    popupWindow.close();
                } else if (popupUrl && new URL(popupUrl).host === new URL(config.redirectUri).host && !code) {
                    clearInterval(checkPopupClosed);
                    reject({
                        status: SocialLoginResponseStatus.Unknown,
                        error: "Login error: " + popupUrl
                    });
                    popupWindow.close();
                }
            } catch (e) {
                // Handle cross-origin errors that indicate window is on a different origin/domain
                console.log(e);
            }
        }, 1000);
    });
};

export { KakaoSdkLogin };
